import { LegalPage, LegalSection } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Privacy() {
  return (
    <LegalPage overline="Legal" title="Privacy Policy" updated="28 June 2026" testid="privacy-page">
      <LegalSection>
        <p>
          <strong>{COMPANY.legal}</strong> ("we", "us") operates {COMPANY.brand}. This Privacy Policy describes
          how we collect, use, disclose and safeguard your information when you use our Platform.
        </p>
      </LegalSection>

      <LegalSection heading="1. Information We Collect">
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Account data:</strong> name, email, phone number and password (stored in encrypted/hashed form).</li>
          <li><strong>Booking &amp; passenger data:</strong> traveller names, age, gender, route, dates and class.</li>
          <li><strong>Payment data:</strong> processed by our payment gateway; we do not store full card details.</li>
          <li><strong>Usage data:</strong> device, browser, IP address and interactions for security and analytics.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="2. How We Use Your Information">
        <p>We use your information to confirm and manage bookings, issue e-tickets, process payments and refunds, provide customer support, prevent fraud, comply with legal obligations, and improve the Platform.</p>
      </LegalSection>

      <LegalSection heading="3. Sharing of Information">
        <p>We share the minimum necessary information with ferry/cruise operators to fulfil your booking, with payment processors to complete transactions, and with authorities where required by law. We do not sell your personal data.</p>
      </LegalSection>

      <LegalSection heading="4. Data Security & Retention">
        <p>We apply industry-standard technical and organisational measures to protect your data and retain it only as long as necessary for the purposes described or as required by law.</p>
      </LegalSection>

      <LegalSection heading="5. Your Rights">
        <p>You may access, correct or request deletion of your personal data, and opt out of marketing communications, by contacting <a href={`mailto:${COMPANY.email}`} className="text-accent font-medium">{COMPANY.email}</a>.</p>
      </LegalSection>

      <LegalSection heading="6. Cookies">
        <p>We use cookies and similar technologies to keep you signed in, remember preferences and measure performance. You can control cookies through your browser settings.</p>
      </LegalSection>

      <LegalSection heading="7. Contact">
        <p>For privacy queries, contact our grievance officer at <a href={`mailto:${COMPANY.grievanceEmail}`} className="text-accent font-medium">{COMPANY.grievanceEmail}</a>.</p>
      </LegalSection>
    </LegalPage>
  );
}
